import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const rootEl = document.getElementById('root');

// Use hydrateRoot when pre-rendered HTML is present (react-snap build),
// otherwise fall back to createRoot for dev server and first-time renders.
if (rootEl.hasChildNodes()) {
  ReactDOM.hydrateRoot(
    rootEl,
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    {
      onRecoverableError: (error) => {
        const msg = error.message || '';
        // Ignore hydration errors usually caused by A/B testing tools (VWO) mutating the DOM
        if (
          msg.includes('Hydration failed') ||
          msg.includes('Text content does not match') ||
          msg.includes('Minified React error #418') ||
          msg.includes('Minified React error #423') ||
          msg.includes('Minified React error #425')
        ) {
          return;
        }
        console.error(error);
      }
    }
  );
} else {
  ReactDOM.createRoot(rootEl).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
